export default __webpack_public_path__ + "static/media/Stock token bnw 3.dc697a05.svg";